import KeyAreaSkillLevel from './key-area-skill-level.entity';
import Skill from './skill.entity';

export default class KeyAreaSkill {
  keyAreaSkillId: string;

  skill: Skill;

  levels: KeyAreaSkillLevel[];

  active: boolean = true;

  order: number = 1;

  isDeletable: boolean = false;

  constructor(obj: any = {}) {
    this.keyAreaSkillId = obj.keyAreaSkillId;
    this.skill = new Skill(obj.skill);
    this.levels = obj.levels.length ? obj.levels.map(level => new KeyAreaSkillLevel(level)) : [];
    this.active = obj.active;
    this.order = obj.order;
    this.isDeletable = obj.isDeletable;
  }

  get skillWhatPTBR() {
    return this.skill.whatPTBR;
  }

  updateDescription(newDescription: string) {
    this.skill.whatPTBR = newDescription;
  }

  inactivate() {
    this.active = false;
  }

  get activeLevels() {
    return this.levels.filter(level => level.active);
  }
}
